const Loader = () => {
    return (
        <div className='flex items-center justify-center w-full h-screen bg-white-500 flex-col gap-6 text-white'>

            <img src="/360-Lernwelt/extras/loading.gif" alt="" />

            {/* <p className='text-6xl  animate-spin'>
                <VscLoading />
            </p>
            <p className='flex '>
                <GoDotFill className='animate-bounce' />
                <GoDotFill className='animate-bounce loader-dot-2' />
                <GoDotFill className='animate-bounce loader-dot-3' />
            </p> */}
        </div>
    )
}

export default Loader